import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { $calendar } from '../../Calendar.store';
import Card from '../Card';
import { usePreparedCardData } from '../Card.hooks';
import styles from './ShiftCard.module.scss';
const ShiftCard = ({ date, data }) => {
    const { t } = useTranslation();
    const shift = $calendar.shifts[data.id];
    const cardData = usePreparedCardData({
        date,
        data,
        itemBegin: shift.begin,
        itemEnd: shift.end,
    });
    return (_jsx(Card, { date: date, data: data, cardData: cardData, colors: !cardData.isPast && { bg: '#FEF3D7', title: '#967522' }, subTitle: t('label.paperwork'), className: styles.wrapper }));
};
export default observer(ShiftCard);
